const NewsHeroSection = () => {
  return (
    <section className="relative bg-slate-900 text-white py-24 lg:py-32 overflow-hidden">
      {/* Subtle Background Accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-blue-900/20 to-transparent pointer-events-none"></div>

      <div className="container mx-auto px-6 max-w-screen-xl relative z-10">
        <div className="px-5 flex flex-col lg:flex-row items-center gap-16">
          {/* --- Left Side: Content --- */}
          <div className="lg:w-1/2 w-full">
            {/* Status Badge */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-500/10 border border-blue-500/30 text-blue-400 text-xs font-bold uppercase tracking-widest mb-6">
              Case Study
            </span>

            {/* Main Title */}
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-white">
              We Built the Future of <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-300">
                Digital Banking
              </span>
            </h1>

            {/* Description */}
            <p className="text-lg text-slate-400 mb-8 leading-relaxed">
              Discover how we engineered a secure, high-speed database and
              mobile banking application for a leading fintech firm in just 3
              months.
            </p>

            {/* Meta Data (Date & Client) */}
            <div className="flex flex-wrap items-center gap-6 mb-10 text-sm font-medium text-slate-300">
              <span className="flex items-center gap-2">
                {/* Green Dot Indicator */}
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                Delivered 2 days ago
              </span>
              <span className="text-slate-600">|</span>
              <span>Client: FinTech Global</span>
            </div>

            {/* CTA Button */}
            <button className="px-8 py-4 bg-white text-slate-900 font-bold rounded-lg hover:bg-slate-200 transition-all duration-300 shadow-lg hover:shadow-2xl hover:-translate-y-1">
              Read Full Story
            </button>
          </div>

          {/* --- Right Side: Featured Image --- */}
          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-2xl overflow-hidden border border-slate-700 shadow-2xl group">
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Fintech Dashboard Project"
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              {/* Dark Overlay at bottom for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent opacity-40"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsHeroSection;
